import * as React from "react";
import { Drawer, List, ListItemButton, ListItemIcon, ListItemText, Toolbar } from "@mui/material";
import { useLocation, useNavigate } from "react-router-dom";
import { navItems } from "@/router/navigation";

export const SIDE_NAV_WIDTH = 240;

interface SideNavigationProps {
  open: boolean;
  onNavigate?: () => void;
  variant: "permanent" | "temporary";
}

export function SideNavigation({
  open,
  onNavigate,
  variant,
}: SideNavigationProps): React.JSX.Element {
  const location = useLocation();
  const navigate = useNavigate();

  return (
    <Drawer
      variant={variant}
      open={open}
      onClose={onNavigate}
      sx={{
        width: SIDE_NAV_WIDTH,
        flexShrink: 0,
        [`& .MuiDrawer-paper`]: { width: SIDE_NAV_WIDTH, boxSizing: "border-box" },
      }}
    >
      <Toolbar />
      <List>
        {navItems.map((item) => {
          const Icon = item.icon;
          const selected = location.pathname.startsWith(item.path);
          return (
            <ListItemButton
              key={item.path}
              selected={selected}
              onClick={() => {
                navigate(item.path);
                onNavigate?.();
              }}
            >
              <ListItemIcon>
                <Icon />
              </ListItemIcon>
              <ListItemText primary={item.label} />
            </ListItemButton>
          );
        })}
      </List>
    </Drawer>
  );
}
